import { useState } from 'react';
import { MAX_YEAR, MIN_YEAR } from '@ardoq/date-time';
import { clamp, range } from 'lodash';
import { DatePickerGrid } from './components';
import { SmallGhostButton } from '@ardoq/button';
import { ChevronDownIcon, ChevronUpIcon } from '@ardoq/icons';

type SelectYearProps = {
  readonly year: number;
  readonly selectedYear: number | null;
  readonly isYearDisabled: (year: number) => boolean;
  readonly selectYear: (year: number) => void;
};

const YEARS_BEFORE_STARTING_YEAR = 4;
const YEARS_AFTER_STARTING_YEAR = 7;
const YEARS_PER_PAGE =
  YEARS_BEFORE_STARTING_YEAR + YEARS_AFTER_STARTING_YEAR + 1;

const SelectYear = ({
  year: startYear,
  selectedYear,
  isYearDisabled,
  selectYear,
}: SelectYearProps) => {
  const [deltaYear, setDeltaYear] = useState(0);

  const onWheel = (delta: number) => {
    const newDeltaYear = deltaYear + delta;
    if (
      startYear + newDeltaYear >= MIN_YEAR &&
      startYear + newDeltaYear <= MAX_YEAR
    ) {
      setDeltaYear(newDeltaYear);
    }
  };
  const yearGridValues: string[] = [];
  getYearRange(startYear, deltaYear).forEach(year => {
    yearGridValues.push(year.toString());
  });

  return (
    <div>
      <SmallGhostButton isFlexible onClick={() => onWheel(-3)}>
        <ChevronUpIcon />
      </SmallGhostButton>
      <DatePickerGrid
        items={getYearRange(startYear, deltaYear).map(n => ({
          label: `${n}`,
          id: `${n}`,
        }))}
        activeItemId={selectedYear ? selectedYear.toString() : null}
        onSelect={id => selectYear(parseInt(id, 10))}
        getIsDisabled={id => isYearDisabled(parseInt(id, 10))}
      />
      <SmallGhostButton isFlexible onClick={() => onWheel(3)}>
        <ChevronDownIcon />
      </SmallGhostButton>
    </div>
  );
};

const getYearRange = (startYear: number, deltaYear: number) => {
  const rangeStart = startYear + deltaYear - YEARS_BEFORE_STARTING_YEAR;
  const rangeEnd = startYear + deltaYear + YEARS_AFTER_STARTING_YEAR;
  return range(
    clamp(rangeStart, MIN_YEAR, MAX_YEAR - YEARS_PER_PAGE + 1),
    clamp(rangeEnd, MIN_YEAR + YEARS_PER_PAGE - 1, MAX_YEAR) + 1
  );
};

export { SelectYear };
